// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	margin: 0 0.5rem 0 0;

	${({ $customMargin }) =>
		$customMargin &&
		css`
			margin: ${$customMargin};
		`}

	${({ $customWidth }) =>
		$customWidth &&
		css`
			width: ${$customWidth};
		`}

	svg {
		fill: ${({ theme: { colors } }) => colors.whiteAlways};
		display: block;
		height: 1em;

		${({ $customHeight }) =>
			$customHeight &&
			css`
				height: ${$customHeight};
			`};

		${({ $customVerticalAlign }) =>
			$customVerticalAlign &&
			css`
				vertical-align: ${$customVerticalAlign};
			`};
	}
`;
const SexIcon = ({
	customHeight,
	customMargin,
	customVerticalAlign,
	customWidth,
}) => {
	return (
		<StyledSvgIconContainer
			$customHeight={customHeight}
			$customMargin={customMargin}
			$customVerticalAlign={customVerticalAlign}
			$customWidth={customWidth}
		>
			<svg viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M15.6667 0H13.4722C13.175 0 13.0278 0.352734 13.2361 0.560547L13.7056 1.02266L12.3528 2.3543C11.7361 1.97148 11.0056 1.75 10.2222 1.75C9.28611 1.75 8.42778 2.06719 7.74444 2.59492C8.13333 3.05156 8.43889 3.5793 8.63611 4.15625C9.03889 3.75156 9.6 3.5 10.2222 3.5C11.4472 3.5 12.4444 4.48164 12.4444 5.6875C12.4444 6.89336 11.4472 7.875 10.2222 7.875C9.60278 7.875 9.03889 7.62344 8.63611 7.21875C8.43889 7.7957 8.13611 8.32344 7.74444 8.78008C8.425 9.31055 9.28611 9.625 10.2222 9.625C12.4306 9.625 14.2222 7.86133 14.2222 5.6875C14.2222 4.91641 13.9972 4.19727 13.6083 3.59023L14.9611 2.25859L15.4306 2.7207C15.4972 2.78633 15.5806 2.81641 15.6639 2.81641C15.8361 2.81641 16 2.68516 16 2.48828V0.328125C16 0.147656 15.85 0 15.6667 0ZM4 1.75C1.79167 1.75 0 3.51367 0 5.6875C0 7.56055 1.33056 9.13008 3.11111 9.52656V10.9375H2.11111C1.92778 10.9375 1.77778 11.0852 1.77778 11.2656V12.3594C1.77778 12.5398 1.92778 12.6875 2.11111 12.6875H3.11111V13.6719C3.11111 13.8523 3.26111 14 3.44444 14H4.55556C4.73889 14 4.88889 13.8523 4.88889 13.6719V12.6875H5.88889C6.07222 12.6875 6.22222 12.5398 6.22222 12.3594V11.2656C6.22222 11.0852 6.07222 10.9375 5.88889 10.9375H4.88889V9.52656C6.66944 9.12734 8 7.56055 8 5.6875C8 3.51367 6.20833 1.75 4 1.75ZM4 7.875C2.775 7.875 1.77778 6.89336 1.77778 5.6875C1.77778 4.48164 2.775 3.5 4 3.5C5.225 3.5 6.22222 4.48164 6.22222 5.6875C6.22222 6.89336 5.225 7.875 4 7.875Z"
					fill="#FF35E6"
				/>
			</svg>
		</StyledSvgIconContainer>
	);
};

export default SexIcon;
